export const getSessionStorageData = key => {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const setSessionStorageData = (key, value) => {
  sessionStorage.setItem(key, value);
};
